import type { Category } from '@/types/software';

export const categories: Category[] = [
  {
    id: 'windows-player',
    name: 'Windows播放器',
    description: '面向 Windows 桌面端的高清影视播放器，支持主流视频格式、硬件加速解码与多声轨切换。',
    icon: 'ri-windows-fill',
  },
  {
    id: 'android-player',
    name: '安卓看片',
    description: '适配 Android 手机与平板，随时随地流畅观看本地或在线影视资源，支持手势调节与投屏。',
    icon: 'ri-android-fill',
  },
  {
    id: 'mac-player',
    name: 'Mac播放器',
    description: '为 macOS 打造的高性能播放器，界面精致，完美契合 Retina 显示屏与原生系统体验。',
    icon: 'ri-apple-fill',
  },
  {
    id: 'ios-player',
    name: 'iOS看片',
    description: 'iPhone 与 iPad 上的轻量播放工具，支持手势操作、后台播放与画中画悬浮窗口。',
    icon: 'ri-smartphone-fill',
  },
  {
    id: 'web-player',
    name: '网页在线播放',
    description: '免安装的网页播放方案，打开浏览器即可直接观看影视内容，跨系统即点即用。',
    icon: 'ri-global-line',
  },
  {
    id: 'tools',
    name: '解码器与辅助工具',
    description: '为各类播放器提供解码增强、画质优化、字幕处理与音轨转换能力的扩展型工具。',
    icon: 'ri-tools-fill',
  },
];